import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { injectIntl } from 'react-intl';
import { alertError, logError } from '../../../../utils';
import { useRouter } from '../../../hooks';
import { userSignUp } from '../../../../api/user';

const initialValues = {
  name: '',
  surname: '',
  email: '',
  phone: '',
  birthdate: '',
  password: '',
  confirmPassword: '',
  role: "patient",
  reason: ''
};

function ContactPage(props) {
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const { token } = router.query;

  const RegisterSchema = Yup.object().shape({
    name: Yup.string()
      .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })),
    surname: Yup.string()
      .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })),
    email: Yup.string()
      .email('Email no válido')
      .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })),
    phone: Yup.string()
      .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })),
    birthdate: Yup.string()
      .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })),
    reason: Yup.string()
      .required('El motivo es obligatorio') // <- nuevo
  });

  const formik = useFormik({
    initialValues,
    validationSchema: RegisterSchema,
    onSubmit: (values, { setSubmitting }) => {
      setTimeout(async () => {
        try {
          const response = await userSignUp(values);
          setLoading(false);
          if (response.status === 201) {
            // alertSuccess({ customMessage: 'Succesfully registered user' })
            router.push('/contact-success');
          }
        } catch (error) {
          logError({ error, customMessage: 'Error registering user.' });
          alertError({ error, customMessage: 'Error registering user.' });
          // setStatus('Invalid Register')
        }
        setLoading(false);
        setSubmitting(false);
      }, 500);
    },
  });

  function formView(placeholder, type, name) {
    return (
      <div className='form-group'>
        <input
          placeholder={placeholder}
          type={type}
          className='form-control'
          name={name}
          {...formik.getFieldProps(name)}
          style={{ fontSize: '16px', padding: '10px' }} // Aumenta el tamaño del campo
        />
        {formik.touched[name] && formik.errors[name] && (
          <div className='error-message'>{formik.errors[name]}</div>
        )}
      </div>
    )
  }

  return (
    <div className='register-form' style={{width: '500px'}}>
      <div className='text-center mb-10'>
        <h4>Regístrate!</h4>
      </div>
      <form onSubmit={formik.handleSubmit} className='form'>
        {formView("Nombre", "text", "name")}
        {formView("Apellidos", "text", "surname")}
        {formView("Email", "email", "email")}
        {formView("Teléfono", "text", "phone")}
        <p style={{marginLeft: 2}}>Fecha de nacimiento</p>
        {formView("Birthdate", "date", "birthdate")}
        <p style={{marginLeft: 2}}>Motivo</p>
        <div className='form-group'>
          <textarea
            name='reason'
            rows={4}
            className='form-control'
            {...formik.getFieldProps('reason')}
            style={{ fontSize: '14px', padding: '10px', resize: 'vertical' }}
          />
          {formik.touched.reason && formik.errors.reason && (
            <div className='error-message'>{formik.errors.reason}</div>
          )}
        </div>

        <button type='submit' disabled={formik.isSubmitting} className='btn btn-primary'>
          {loading ? 'Registrando...' : 'Regístrate'}
        </button>
      </form>
     
    </div>
  );
}

export default injectIntl(ContactPage);
